<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
//  import MsClientHome from '@/components/client/Home'
  import MsTouristHome from '@/components/tourist/Home'

  export default {
    name: 'ms-home',
    components: {
//      MsClientHome,
      MsTouristHome
    },
    computed: {
      userType () {
        const userInfo = this.$store.state.user.info || {}
        return userInfo['type'] || ''
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Home.vue